/* ShadowsDeal legacy product controller archived 2026-09-14.
   Active product behavior now lives in shadows-commerce2.js and shadows-final-polish.js.
   The full previous controller is preserved in assets/shadows-product-upgrade.pre-final-polish-0914.js. */
window.ShadowsDealLegacyProductUpgradeArchived = true;
